import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, IconButton, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import axios from 'axios';
import { decrypt } from '../../../Security';

const PostImageUploadComponent = ({ uploadedImages, setUploadedImages, handleDeleteUpload, createMode }) => {
 

 
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      // const filePreviews = files.map(file => URL.createObjectURL(file));
      // setSelectedImages((prevImages) => [...prevImages, ...filePreviews]);

      files.forEach(file => {
        handleUpload(file);
      });
    }
  };

  const handleDelete = async (index) => {
    const imageToDelete = uploadedImages[index];
    // setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setUploadedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    if (imageToDelete) {
      
      await handleDeleteUpload(imageToDelete);
    }
  };

 

  const handleUpload = async (imageFile) => {
    if (!imageFile) {
      console.error('No image file available to upload');
      return;
    }

    const formData = new FormData();
    formData.append('image', imageFile);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PUBLIC_SERVER_URI}/api/v1/media/upload-image`,
        formData,
        {
          headers: {},
          withCredentials: true,
        }
      );

      const imageUrl = decrypt(response.data).imageUrl;
      setUploadedImages((prevImages) => [...prevImages, imageUrl]);
      console.log('Image uploaded successfully:', imageUrl);
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  return (
    <Box
      sx={{ 
        padding: 2,
        border: 1,
        borderColor: 'grey.300',
        borderRadius: 2,
      }}
    >
      <Grid container spacing={2}>
        {uploadedImages.map((image, index) => (
          <Grid item key={index}>
            <Box
              sx={{
                position: 'relative',
                width: 'auto',
                height: 500,
              }}
            >
              <Box
                component="img"
                src={image}
                alt={`Selected ${index}`}
                sx={{
                  width: 500,
                  height: 500,
                  borderRadius: 1,
                  objectFit: 'cover',
                }}
              />
             { <IconButton
                onClick={() => handleDelete(index)}
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  backgroundColor: 'white',
                  borderRadius: '50%',
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>}
            </Box>
          </Grid>
        ))}
      </Grid>

      {(
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            {createMode?"Please select images to upload":"Please select images to append to the existing post"}
          </Typography>
          <Button
            variant="outlined"
            component="label"
            color="success"
            sx={{ textTransform: 'none' }}
          >
            Choose Files
            <input
              type="file"
              accept="image/*"
              hidden
              multiple
              onChange={handleImageChange}
            />
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PostImageUploadComponent;
